import { profileCompletionFlags } from "../assets/interface/primeSharkWebsite_interface";
import { ActiveProfilesInterface } from "../components/Login/interface";

export const PROFILE_SWITCH = "PROFILE_SWITCH";
export const HAS_CHANGED_PROFILE = "HAS_CHANGED_PROFILE";
export const REGISTER_IDS = "REGISTER_IDS";
export const DELETE_IDS = "DELETE_IDS";
export const PROFILE_DETAIL = "PROFILE_DETAIL";
export const STORE_DEVICE_TOKEN = "STORE_DEVICE_TOKEN";
export const PREFFERED_CURRENCY = "PREFFERED_CURRENCY";
export const ACTIVE_SUBSCRIPTION = "ACTIVE_SUBSCRIPTION";
export const ACTIVE_LOGIN_TYPE = "ACTIVE_LOGIN_TYPE";
export const PROFILE_COMPLETION_FLAGS = "PROFILE_COMPLETION_FLAGS";
export const ACTIVE_PROFILES = "ACTIVE_PROFILES";
export const RESET_STORE = "RESET_STORE";
export const ACCESS_DATA = "ACCESS_DATA";
export const STORE_PASSWORD="STORE_PASSWORD";
export const DELETE_FCM="DELETE_FCM";
export const AI_SCORE="AI_SCORE";
export const PROFILE_JOURNEY_INFO = "PROFILE_JOURNEY_INFO";


export const hasChangedProfile = (payload: any) => ({
  type: "HAS_CHANGED_PROFILE",
  payload: payload,
});

export const profileSwitchList = (payload: any) => ({
  type: PROFILE_SWITCH,
  payload: payload,
});
export const profileDetail = (payload: any) => ({
  type: PROFILE_DETAIL,
  payload: payload,
});

export const storeRegisteredToken = (payload: any) => ({
  type: STORE_DEVICE_TOKEN,
  payload: payload,
});
export const registrationId = (payload: any) => ({
  type: REGISTER_IDS,
  payload: payload,
});

export const removeRegistrationIds = (payload: any) => ({
  type: DELETE_IDS,
  payload,
});
export const removeFCMToken = (payload: any) => ({
  type: DELETE_FCM,
  payload,
});
export const storePrefferedCurrency = (payload: any) => ({
  type: PREFFERED_CURRENCY,
  payload,
});
export const storeActiveSubscription = (payload: any) => ({
  type: ACTIVE_SUBSCRIPTION,
  payload,
});
export const storeLoginAccountTypes = (payload: any) => ({
  type: ACTIVE_LOGIN_TYPE,
  payload,
})
export const storeProfileCompletionFlags = (payload: profileCompletionFlags) => ({
  type: PROFILE_COMPLETION_FLAGS,
  payload,
})

export const storeActiveProfiles = (payload: ActiveProfilesInterface) => ({
  type: ACTIVE_PROFILES,
  payload,
})

export const resetStore = () => ({
  type: RESET_STORE,
});

export const storeAccessData = (payload: any) => ({
  type: ACCESS_DATA,
  payload,
})

export const storePassword = (payload: any) => ({
  type: STORE_PASSWORD,
  payload,
})


export const storeAIScore = (payload: any) => ({
  type: AI_SCORE,
  payload,
})

export const profileJourneyInfo = (payload: any) => ({
  type: PROFILE_JOURNEY_INFO,
  payload,
})